// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Profunctor from "../Data.Profunctor/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var show = /* #__PURE__ */ Data_Show.show(Fusion_Data_Duration.showDuration);
var pure = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Fusion_Data_Duration.decodeJsonDuration);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var fromStr1 = /* #__PURE__ */ Fusion_Data_Duration.fromStr();
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var dimap = /* #__PURE__ */ Data_Profunctor.dimap(/* #__PURE__ */ Data_Codec.profunctorCodec(Data_Either.functorEither));
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Fusion_Data_Duration.encodeJsonDuration);
var append = /* #__PURE__ */ Data_Semigroup.append(Fusion_Data_Duration.semigroupDuration);
var Timestamp = function (x) {
    return x;
};
var showTimestamp = {
    show: function (v) {
        return Data_String_Common.replace("D.fromStr")("T.fromStr")(show(v));
    }
};
var ordTimestamp = Fusion_Data_Duration.ordDuration;
var eqTimestamp = Fusion_Data_Duration.eqDuration;
var toOld = function (v) {
    var v1 = Fusion_Data_Duration.toOld(v);
    return v1;
};
var timeIntervalSince1970 = Timestamp;
var arbitraryTimestamp = {
    arbitrary: /* #__PURE__ */ Control_Bind.bind(Test_QuickCheck_Gen.bindGen)(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(Fusion_Data_Duration.arbitraryDuration))(function (v) {
        return pure(timeIntervalSince1970(v));
    })
};
var decodeJsonTimestamp = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (v) {
            return pure1(timeIntervalSince1970(v));
        });
    }
};
var fromStr = function () {
    return function (str) {
        return fromStr1(str);
    };
};
var fromOld = function (v) {
    return Fusion_Data_Duration.fromOld(v);
};
var durToTs = timeIntervalSince1970;
var diff = function (v) {
    return function (v1) {
        return Fusion_Data_Duration.sub(v)(v1);
    };
};
var tsToDur = function (ts) {
    return diff(ts)(timeIntervalSince1970(mempty));
};
var jsonCodecSeconds = /* #__PURE__ */ dimap(tsToDur)(durToTs)(Fusion_Data_Duration.jsonCodecSeconds);
var strCodecSeconds = /* #__PURE__ */ dimap(tsToDur)(durToTs)(Fusion_Data_Duration.strCodecSeconds);
var encodeJsonTimestamp = {
    encodeJson: function (ts) {
        var d = diff(ts)(timeIntervalSince1970(mempty));
        return encodeJson(d);
    }
};
var addDuration = function (v) {
    return function (d) {
        return append(v)(d);
    };
};
export {
    addDuration,
    diff,
    fromOld,
    fromStr,
    strCodecSeconds,
    jsonCodecSeconds,
    timeIntervalSince1970,
    toOld,
    eqTimestamp,
    ordTimestamp,
    showTimestamp,
    arbitraryTimestamp,
    decodeJsonTimestamp,
    encodeJsonTimestamp
};
